<div class="action-card">
  <div class="left-panel">
    <h2 class="iris-h2-responsive">
      Not sure where to start? Simplify your journey with our free all-in-one wellness app.
    </h2>
    <b *ngIf="!(breakpointsService.isMobile$ | async)" class="iris-body-responsive">
      Scan the QR code to download the SonderMind app
    </b>
  </div>

  <iris-button-container *ngIf="breakpointsService.isMobile$ | async" class="right-panel">
    <iris-button
      [type]="irisButtonTypes.SECONDARY"
      [linkHref]="isAndroid ? ANDROID_SONDERMIND_APP_LINK : APPLE_SONDERMIND_APP_LINK"
      (click)="handleClick()"
    >
      Get the app
    </iris-button>
  </iris-button-container>

  <div *ngIf="!(breakpointsService.isMobile$ | async)" class="right-panel">
    <div class="qr-code-background">
      <img [src]="urlBase + '/assets/prod-qr-code.svg'">
    </div>
  </div>
</div>